import PWAdminCmdKItem from "./PWAdminCmdKItem"
import { PWAdminCmdKOption } from "./types"

const PWAdminCmdKItems = ({ options }: { options: PWAdminCmdKOption[] }) => {
  return options.map((option) => (
    <PWAdminCmdKItem key={option.label} option={option} />
  ))
}

export default PWAdminCmdKItems
